import React from 'react'

import { Form, CheckboxProps } from 'semantic-ui-react'
import { Typography, Box, Card, CardContent } from '@mui/material'

import CustomLabel from '../../../components/common/custom-label/CustomLabel'

import { IProject } from '../../../api/Data'

const FormatsCard = (props: IProps) => {
  // Props
  const { project, handleChange } = props

  const { allowRecordVideo, allowUploadFile, allowQrCode } = project

  const handleCheckboxChange = (e: React.MouseEvent<HTMLInputElement, MouseEvent>, data: CheckboxProps) => {
    const { name, checked } = data
    
    handleChange(e, {
      name: String(name),
      checked:  Boolean(checked),
    })
  }
  
  return (
    <Card sx={{ width: '100%', boxSizing: 'border-box' }}>
      <CardContent>
        <Box display="flex" flexDirection="column" gap={2}>
          <Typography variant="h5" fontWeight="bold">
            Upload Formats
          </Typography>
          <Form>
            <Form.Field>
              <CustomLabel>
                <CustomLabel.Text text="Device Camera" />
                <CustomLabel.Popup popupContent="Allow contributors to record videos from their device cameras" />
                <CustomLabel.Checkbox
                  name="allowRecordVideo"
                  checked={allowRecordVideo}
                  onClick={handleCheckboxChange}
                />
              </CustomLabel>
            </Form.Field>
            <Form.Field>
              <CustomLabel>
                <CustomLabel.Text text="Upload Files" />
                <CustomLabel.Popup popupContent="Allow contributors to upload prerecorded videos from their devices" />
                <CustomLabel.Checkbox
                  name="allowUploadFile"
                  checked={allowUploadFile}
                  onClick={handleCheckboxChange}
                />
              </CustomLabel>
            </Form.Field>
            <Form.Field>
              <CustomLabel>
                <CustomLabel.Text text="Display QR Code" />
                <CustomLabel.Popup popupContent="Allow contributors to upload from another device via a QR code" />
                <CustomLabel.Checkbox
                  name="allowQrCode"
                  checked={allowQrCode}
                  onClick={handleCheckboxChange}
                />
              </CustomLabel>
            </Form.Field>
          </Form>
        </Box>
      </CardContent>
    </Card>
  )
}

interface IProps {
  project: IProject
  handleChange: (
    arg: React.SyntheticEvent,
    { name, checked }: { name: string; checked: boolean }
  ) => void
}

export default FormatsCard
